import * as React from "react";
import { SVGProps } from "react";
const SvgRoundStar = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="#000"
      d="m8 11.514 2.767 1.673a.665.665 0 0 0 .993-.72l-.733-3.147 2.446-2.12a.665.665 0 0 0-.38-1.167l-3.22-.273-1.26-2.973a.667.667 0 0 0-1.226 0l-1.26 2.966-3.22.274a.665.665 0 0 0-.38 1.167l2.446 2.12-.733 3.146a.665.665 0 0 0 .993.72L8 11.514Z"
    />
  </svg>
);
export default SvgRoundStar;
